import { Loader, CategoryPage } from '@monorepo-nx/std-watch/ui'
import { useRouter } from 'next/router';
import { AppContext, CategoryPageSEO, getAuthors, getCategoryPageBySlug, getMenuByName, getPostsByCategoryId } from "@monorepo-nx/std-watch/services"
import { useContext } from 'react';
import moment from 'moment';
import {Layout} from '@monorepo-nx/std-watch/ui';


const CategoryIndexPage = ({ posts, authors, categoryPage, pagination, mainMenu}) => {
  const category = categoryPage.slug;
  const router = useRouter();
  const pagesCount = Math.ceil(pagination.total / pagination.showPerPage)

  const { setCategoryPageData } = useContext(AppContext);
  setCategoryPageData(categoryPage)


  if (router.isFallback) {
    return <Loader />;
  }
  const paginationConfig = {
    firstPagePath:`/${category}`,
    ...pagination
  }
  
  return (
    <Layout mainMenu={mainMenu}>
      <CategoryPageSEO
        title={categoryPage.title}
        category={category}
        currentPage={pagination.currentPage} 
        coverImage={posts[0]?.coverImage}
        pagesCount={pagesCount}
        dateModified={posts[0]?.createdAt ? moment(posts[0].createdAt).format('MMM DD, YYYY') : undefined}
        />
      <CategoryPage
        title={categoryPage.title}
        posts={posts}
        authors={authors}
        category={category}
        categoryPage={categoryPage}
        pagination={paginationConfig}
        />
    </Layout>
  );
}
export default CategoryIndexPage;


export async function getServerSideProps({ req, res, params, query }) {
  const pageSize = query.pageSize || 19;
  const currentPage = query.page ? parseInt(query.page, 10) : 1;
  const skip = query.page ? (query.page - 1) * pageSize : 0;
  const [ authors, { categoryPage }, mainMenuData, footerData] = await Promise.all([
      getAuthors(),
      getCategoryPageBySlug(params.categorySlug),
      getMenuByName("Main"),
      getMenuByName("Footer")
    ]);
  const  { edges, aggregate }  = await getPostsByCategoryId(categoryPage?.category.id, skip, pageSize)
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=3600, stale-while-revalidate=59'
  )
  categoryPage.slug = params.categorySlug;
  return {
    props: {
      posts: edges.map(({ node }) => node),
      pagination: {
        total: aggregate.count,
        // Todo rename prefix to path
        prefix: `/${params.categorySlug}`,
        currentPage,
        pageSize,
      },
      authors,
      categoryPage,
      mainMenu: mainMenuData.content,
      footer: footerData.content,
    },
  };
}

// export async function getStaticPaths() {
//   const { menu } = await getMenuBySlug("main-menu")
//   const paths = menu.items.map(({ slug }) => ({ params: { categorySlug: slug } }));

//   return {
//     paths,
//     fallback: 'blocking',
//   }
// }

